export default {
  paymentAutomationForm: {
    status: 0,
    data: {
      configuration_id: null,
      excluded_reservation_sources: [],
      immediately_send_payment_request: false
    }
  },
  stripeForm: {
    position: -5,
    status: 0,
    type: null,
    data: {
      terms: null,
      variant: 3,
      accepted_cards: [],
      pay_now_config: "NONE",
      applicationFee: null
    }
  },
  stripe2Form: {
    position: -4,
    status: 0,
    type: null,
    data: {
      terms: null,
      variant: 3,
      accepted_cards: []
    }
  },
  transferForm: {
    position: -3,
    status: 0,
    type: null,
    data: {
      account_holder: null,
      bank_name: null,
      iban: null,
      swift: null,
      terms: null,
      advance_days: null,
      is_only_not_refundable: false
    }
  },
  cashForm: {
    position: -2,
    status: 0,
    type: null,
    data: {
      days_advance: null,
      mobile_only: false,
      terms: null
    }
  },
  nexiForm: {
    position: -1,
    status: 0,
    type: null,
    data: {
      alias: null,
      mac: null,
      variant: null,
      accepted_cards: []
    }
  },
  creditCardForm: {
    position: 0,
    status: 0,
    type: null,
    data: {
      accepted_cards: [],
      terms: null,
      ciccio: null
    }
  }
};
